import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { getNestedPropertyOrDefault } from 'style-utils/core/createExtractCssFromProps/utils/getNestedPropertyOrDefault';
import { isNumber } from 'utils/functions/isNumber';

const getMargin = (marginPropValue: any, themeKey: object) => {
  if (!isNumber(marginPropValue)) {
    return getNestedPropertyOrDefault(
      themeKey,
      marginPropValue,
      marginPropValue,
    );
  }
  const isNegative = marginPropValue < 0;
  const absolute = Math.abs(marginPropValue);
  const value = getNestedPropertyOrDefault(themeKey, absolute, absolute);

  if (!isNumber(value)) {
    return isNegative ? '-' + value : value;
  }
  return value * (isNegative ? -1 : 1);
};

const marginMappedProperties = {
  margin: {
    property: 'margin',
    transform: getMargin,
  },
  marginTop: {
    property: 'marginTop',
    transform: getMargin,
  },
  marginRight: {
    property: 'marginRight',
    transform: getMargin,
  },
  marginBottom: {
    property: 'marginBottom',
    transform: getMargin,
  },
  marginLeft: {
    property: 'marginLeft',
    transform: getMargin,
  },
  marginX: {
    properties: ['marginLeft', 'marginRight'],
    transform: getMargin,
  },
  marginY: {
    properties: ['marginTop', 'marginBottom'],
    transform: getMargin,
  },
};

const mappedMarginPropertiesShortcuts = {
  m: marginMappedProperties.margin,
  mt: marginMappedProperties.marginTop,
  mr: marginMappedProperties.marginRight,
  mb: marginMappedProperties.marginBottom,
  ml: marginMappedProperties.marginLeft,
  mx: marginMappedProperties.marginX,
  my: marginMappedProperties.marginY,
};

export type WithMarginProps = Partial<
  Record<keyof typeof mappedMarginPropertiesShortcuts, StyledPropType>
>;

export const withMargin = createExtractCssFromProps(
  mappedMarginPropertiesShortcuts,
);
